import { ONE } from '@drift-labs/sdk';
import { MarketId } from '@drift/common';
import {
	useTargetPerpMarketAccount,
	useTargetSpotMarketAccount,
} from './useTargetMarketAccount';

const useTickSizeForMarket = (marketId: MarketId) => {
	const spotMarketAccount = useTargetSpotMarketAccount(marketId);
	const perpMarketAccount = useTargetPerpMarketAccount(marketId);

	const tickSizeForMarket = marketId.isPerp
		? perpMarketAccount?.amm?.orderTickSize ?? ONE
		: spotMarketAccount?.orderTickSize ?? ONE;

	return tickSizeForMarket;
};

export default useTickSizeForMarket;
